import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { HelperService } from 'app/shared/services/helper.service';
import { ServiceProviderService } from 'app/shared/services/service-provider.service';
import { AlertServiceService } from 'app/shared/services/alert-service.service';
import { ApiService } from 'app/shared/services/api.service';
@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FormsComponent implements OnInit {
  @Input() formData: Array<any> = [];
  @Input() showAction: any = { edit: false }
  @Input() editRoutePath: string = '/'
  @Input() editKey: string = '_id'
  @Output() ngSubmit = new EventEmitter();
  @Output() update = new EventEmitter();
  @Output() change = new EventEmitter();

  env: any;
  assignedServices: any;
  mappedList: any;
  currentValue: any;

  constructor(
    public hp: HelperService,
    public api: ApiService,
    private ss: ServiceProviderService,
    private as: AlertServiceService
  ) {
    this.env = environment
  }

  ngOnInit(): void {
    this.getServiceList();
    this.getEdit();
    if (this.api?.editableData?.accountType === 'payout') {
      this.currentValue = 'collect';
    }
  }

  getServiceList() {
    const subs: Subscription = this.ss.getServiceProvider().subscribe({
      next: (res: any) => {
        if (res.success) {
          this.mappedList = res.data.map((obj: any) => {
            return {
              id: obj._id,
              name: obj.name,
              text: ` ${obj.name} -  ( ${obj.sub_service_name} )`,
            };
          });

        } else {
          this.as.errorToast(res.message);
        }
      },
      error: (err: any) => console.log(err.message),
      complete: () => subs.unsubscribe(),
    });
  }

  getValue(e: any, cName: string) {
    if (cName == 'accountType') {
      this.currentValue = e.target.value.split(':')[1].trim();
    }
  }

  public onSelectAll() {
    if (this.showAction.edit) {
      this.api.editableData.assignedServices = this.mappedList.map((item: any) => item.id);
    }
    this.assignedServices = this.mappedList.map((item: any) => item.id);
  }
  public onClearAll() {
    if (this.showAction.edit) {
      this.api.editableData.assignedServices = []
    }
    this.assignedServices = [];
  }

  submit(frm: NgForm) {
    this.ngSubmit.emit(frm)

  }
  updatedata(frm: NgForm) {
    this.update.emit(frm)

  }
  selectFile(e: any) {
    this.change.emit(e)
  }

  getOne() {
    if (this.showAction.edit) {
      this.api.getOne(this.editRoutePath, { id: this.editKey });
    }
  }

  getEdit() {
    if (this.showAction.edit) {
      this.api.getOne(this.editRoutePath, { id: this.editKey });
    }
  }

}
